"use client";

import { type ReactNode, useRef } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface MovingBorderButtonProps {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  borderClassName?: string;
  duration?: number;
  onClick?: () => void;
}

export function MovingBorderButton({
  children,
  className,
  containerClassName,
  borderClassName,
  duration = 3000,
  onClick,
}: MovingBorderButtonProps) {
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <button
      ref={btnRef}
      onClick={onClick}
      className={cn(
        "relative inline-flex h-12 overflow-hidden rounded-xl p-[2px] focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background",
        containerClassName
      )}
    >
      <motion.span
        className={cn(
          "absolute inset-[-100%] bg-[conic-gradient(from_0deg,transparent_0_340deg,var(--color-primary)_360deg)]",
          borderClassName
        )}
        animate={{ rotate: 360 }}
        transition={{
          duration: duration / 1000,
          repeat: Infinity,
          ease: "linear",
        }}
      />
      <span
        className={cn(
          "relative z-10 inline-flex h-full w-full cursor-pointer items-center justify-center gap-2 rounded-[10px] bg-primary px-6 text-sm font-medium text-primary-foreground backdrop-blur-3xl transition-colors hover:bg-primary/90",
          className
        )}
      >
        {children}
      </span>
    </button>
  );
}
